export default {
  "content": "<title>Nuclear</title><circle cx=\"256\" cy=\"256\" r=\"192\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"256\" r=\"64\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M224 192L171 85m117 107l53-107m-13.45 170.81l119.41.13m-147.87 57.19l72.25 95.06M184.45 255.81l-119.41.13m147.87 57.19l-72.25 95.06\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};